import { useMemo } from 'react';
import { useLocation, useRouteMatch } from 'react-router-dom';

const justModuleAndFeatureRegex = /^\/\w+\/\w+/g;

const useAsiteRelaticsRoutes = () => {
    const { path, url } = useRouteMatch();
    const { pathname } = useLocation();

    // Improvement - Redirect if no correct route is passed here
    const matchedPathname = pathname.match(justModuleAndFeatureRegex) || '';

    const routes = useMemo(
        () => ({
            logs: `${path}/logs`
        }),
        [path],
    );

    return { routes, path, url, matchedPathname };
};

export default useAsiteRelaticsRoutes;
